var _ellipse, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTikhon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.6684,
    cy: 26,
    rx: 25.6684,
    ry: 26,
    fill: "#13B75B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 26,
    r: 26,
    fill: "#13B75B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 25.9998C25.1667 25.9998 23.5972 25.3471 22.2917 24.0415C20.9861 22.7359 20.3334 21.1665 20.3334 19.3332C20.3334 17.4998 20.9861 15.9304 22.2917 14.6248C23.5972 13.3193 25.1667 12.6665 27 12.6665C28.8334 12.6665 30.4028 13.3193 31.7084 14.6248C33.0139 15.9304 33.6667 17.4998 33.6667 19.3332C33.6667 21.1665 33.0139 22.7359 31.7084 24.0415C30.4028 25.3471 28.8334 25.9998 27 25.9998ZM13.6667 39.3332V34.6665C13.6667 33.7221 13.9097 32.854 14.3959 32.0623C14.882 31.2707 15.5278 30.6665 16.3334 30.2498C18.0556 29.3887 19.8056 28.7429 21.5834 28.3123C23.3611 27.8818 25.1667 27.6665 27 27.6665C28.8334 27.6665 30.6389 27.8818 32.4167 28.3123C34.1945 28.7429 35.9445 29.3887 37.6667 30.2498C38.4722 30.6665 39.1181 31.2707 39.6042 32.0623C40.0903 32.854 40.3334 33.7221 40.3334 34.6665V39.3332H13.6667ZM17 35.9998H37V34.6665C37 34.3609 36.9236 34.0832 36.7709 33.8332C36.6181 33.5832 36.4167 33.3887 36.1667 33.2498C34.6667 32.4998 33.1528 31.9373 31.625 31.5623C30.0972 31.1873 28.5556 30.9998 27 30.9998C25.4445 30.9998 23.9028 31.1873 22.375 31.5623C20.8472 31.9373 19.3334 32.4998 17.8334 33.2498C17.5834 33.3887 17.382 33.5832 17.2292 33.8332C17.0764 34.0832 17 34.3609 17 34.6665V35.9998ZM27 22.6665C27.9167 22.6665 28.7014 22.3401 29.3542 21.6873C30.007 21.0346 30.3334 20.2498 30.3334 19.3332C30.3334 18.4165 30.007 17.6318 29.3542 16.979C28.7014 16.3262 27.9167 15.9998 27 15.9998C26.0834 15.9998 25.2986 16.3262 24.6459 16.979C23.9931 17.6318 23.6667 18.4165 23.6667 19.3332C23.6667 20.2498 23.9931 21.0346 24.6459 21.6873C25.2986 22.3401 26.0834 22.6665 27 22.6665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikhon);
export default __webpack_public_path__ + "static/media/tài khoản.212ff0d8239f9ba3c2ee02eeea4f1161.svg";
export { ForwardRef as ReactComponent };